<template>
  <div>
    <!-- 공지 쓰기 버튼 -->

    <!-- TODO: 공지 기능이 완성되면 주석풀고 사용 -->
    <!-- 
    <b-button v-if="is_admin === 4" variant="teal" size="sm" class="mb-2" @click="openWriteNoticeModal">
      <b-icon icon="pen"/>
      공지 쓰기(관리자)
    </b-button> 
    -->

    <div role="tablist">
      <b-button
        v-b-toggle.notices
        variant="teal"
        block
        class="text-left mb-2 d-flex justify-content-between align-items-center button-with-icon"
        role="tab"
        @click="toggleCollapse('notices')"
      >
        공지사항
        <b-icon
          class="collapse-icon"
          :icon="isNoticesCollapsed ? 'caret-up-fill' : 'caret-down-fill'"
        />
      </b-button>

      <b-collapse id="notices" role="tabpanel" visible accordion="my-accordion">
        <template v-if="notice_list && notice_list.length > 0">
          <p v-if="!isRead">확인되지 않은 공지가 <span class="red">1</span>개 있습니다.</p>
          <b-card
            v-for="notice in notice_list"
            :key="notice.notice_id"
            no-body
            class="px-3 py-2 w-100 mb-1 cursor notice-card"
            @click="openNoticeModal(notice)"
          >
            <div>
              <p class="f-85 fw-500">{{ notice.title }}</p>
              <div class="d-flex justify-content-between">
                <p class="mb-0 f-85 fw-300">{{ formatTimestamp(notice.time_stamp) }}</p>
                <template v-if="isRead">
                  <b-icon class="mr-1" scale="1.1" variant="success" icon="check2-square" />
                </template>
                <template v-else>
                  <b-icon class="mr-1" scale="1.1" variant="danger" icon="square" />
                </template>
              </div>
            </div>
          </b-card>
        </template>
        <template v-else>
          <b-card no-body class="px-3 py-2 w-100 f-85 mb-3"> 등록된 공지가 없습니다. </b-card>
        </template>
      </b-collapse>
      <b-button
        v-b-toggle.messages
        variant="teal"
        block
        class="text-left mb-2 d-flex justify-content-between align-items-center button-with-icon"
        role="tab"
        @click="toggleCollapse('messages')"
      >
        <div>
          메세지
          <span v-if="new_notice" class="red">{{ new_notice }}</span>
        </div>

        <b-icon
          class="collapse-icon"
          :icon="isMessagesCollapsed ? 'caret-up-fill' : 'caret-down-fill'"
        />
      </b-button>

      <b-collapse id="messages" role="tabpanel" accordion="my-accordion">
        <template v-if="mention_list && mention_list.length > 0">
          <b-card
            v-for="mention in reversedMentionList"
            :key="mention.id"
            no-body
            class="px-3 py-2 w-100 mb-1 cursor mention-card"
            @click="handleMentionClick(mention)"
            @mouseover="hoverId = mention.id"
            @mouseleave="hoverId = null"
          >
            <div>
              <p class="f-85 fw-500 mb-0">
                {{ mention.report_name + '에서 ' + mention.title || '제목 없음' }}
              </p>
              <p class="f-85 fw-500 mb-0">
                {{ mention?.sb_toc_lv1_name }} > {{ mention?.sb_toc_lv2_name }}
              </p>

              <div>
                <p class="mb-0 f-85">
                  {{ mention.sender_name }},
                  <span class="f-85">{{ truncateText(mention.content, 30) }}</span>
                </p>
              </div>
            </div>

            <div class="d-flex justify-content-between">
              <p class="mb-0 f-85 fw-300">{{ formatTimestamp(mention.time_stamp) }}</p>
              <template v-if="mention.has_read">
                <b-icon class="mr-1" scale="1.1" variant="success" icon="check2-square" />
              </template>
              <template v-else>
                <b-icon class="mr-1" scale="1.1" variant="danger" icon="square" />
              </template>
            </div>
            <!-- 삭제 버튼 -->
            <b-button
              v-if="hoverId === mention.id"
              class="delete-button"
              variant="link-danger"
              size="sm"
              @click.stop="deleteMention(mention.id)"
            >
              <b-icon icon="trash-fill" />
            </b-button>
          </b-card>
        </template>
        <template v-else>
          <b-card no-body class="px-3 py-2 w-100 f-85 mb-3"> 등록된 멘션이 없습니다. </b-card>
        </template>
      </b-collapse>

      <b-button
        v-b-toggle.activity-logs
        variant="teal"
        block
        class="text-left mb-2 d-flex justify-content-between align-items-center button-with-icon"
        role="tab"
        @click="toggleCollapse('activityLogs')"
      >
        활동 기록
        <b-icon
          class="collapse-icon"
          :icon="isActivityLogsCollapsed ? 'caret-up-fill' : 'caret-down-fill'"
        />
      </b-button>

      <b-collapse id="activity-logs" role="tabpanel" accordion="my-accordion">
        <template v-if="activity_logs_loaded == true">
          <b-card v-for="log in activity_logs" :key="log.id" no-body class="px-3 py-2 mb-1 w-100">
            <p class="f-85">{{ log.activity }}</p>
            <div class="d-flex justify-content-between align-items-center">
              <p class="f-85 mb-0">{{ log.time_stamp }}</p>
              <div
                v-b-tooltip.hover
                :title="getReportName(log.report_code)"
                class="px-1"
                :style="`color:${getMainColor(log.report_code)}`"
              >
                <fa icon="bookmark" />
              </div>
            </div>
          </b-card>
        </template>
      </b-collapse>
    </div>

    <!-- 공지 쓰기 모달 -->
    <b-modal
      id="write-notice-modal"
      title="공지 쓰기(테스트중)"
      hide-footer
      size="xl"
      centered
      scrollable
      @hide="resetNoticeForm"
    >
      <b-form @submit.prevent="submitNotice">
        <b-form-group label="제목" label-for="notice-title">
          <b-form-input id="notice-title" v-model="noticeForm.title" required />
        </b-form-group>
        <b-form-group label="내용" label-for="notice-content">
          <b-form-textarea id="notice-content" v-model="noticeForm.content" rows="5" required />
        </b-form-group>
        <b-button variant="teal" class="mr-2" @click="submitNotice">등록</b-button>
        <b-button variant="secondary" @click="$bvModal.hide('write-notice-modal')">취소</b-button>
      </b-form>
    </b-modal>

    <!-- 공지사항 상세 모달 -->
    <b-modal
      id="notice-modal"
      :title="selectedNotice ? selectedNotice.title : ''"
      size="xl"
      centered
      scrollable
      @hide="markNoticeAsRead(selectedNotice)"
    >
      <div v-if="selectedNotice">
        <p v-html="formatContent(selectedNotice.content)"></p>

        <!-- Download Attachment Link -->
        <div v-if="selectedNotice.attachment" class="mt-3">
          <a
            :href="selectedNotice.attachment.url"
            target="_blank"
            download
            :title="selectedNotice.attachment.name"
          >
            <b-icon icon="download" />
            {{ selectedNotice.attachment.name }}
          </a>
        </div>
      </div>
      <template #modal-footer>
        <b-button variant="primary" @click="markNoticeAsRead(selectedNotice)">확인</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import Notice from './Notice.js';
import * as ih from '@/components/util';

export default {
  name: 'LogAndNotice',
  mixins: [Notice],
  data() {
    return {
      hoverId: null,
      isNoticesCollapsed: true,
      isActivityLogsCollapsed: false,
      isMessagesCollapsed: false,
      selectedNotice: null,
      noticeForm: {
        title: '',
        content: ''
      },
      notice_list: [
        {
          notice_id: 1,
          title: '마이크로사이트 형식 보고서 작성 신규 기능 출시 및 가격 정책 업데이트',
          content: `안녕하세요, ERT 사용자 여러분
퀀티파이드이에스지 입니다.

1. 마이크로 웹사이트 형식의 ESG 웹보고서 작성 기능 신규 출시

2024년 11월 14일  마이크로사이트 형식의 ESG웹보고서 작성 신규 기능이 출시됩니다.
기존 GRI, SASB, TCFD 기준 개별 index 보고서 외 일반적인 마이크로 웹사이트 형태의 웹보고서를 플랫폼을 통해 구축할 수 있는 기능입니다.
해당 기능을 통해 기업이 자체적인 목차 구조를 생성하고, 페이지 별로 고유 주소를 가진 웹 ESG 보고서를 손쉽게 만들 수 있습니다.
차년도 ESG 보고에 활용 검토 부탁드립니다.

2. 가격정책 업데이트

신규 기능 출시에 따라, 유료 계정이 권한별로 베이직/프로 계정으로 세분화 될 예정입니다.
(*마이크로 웹사이트 작성 기능은 "프로 계정"부터 사용하실 수 있습니다.)

기존 계정은 "베이직"으로 전환됩니다.
베이직은 기존 유료 계정과 권한 및 가격이 동일하며, 기존에 이용하시던 기능은 모두 이용하실 수 있습니다.
본 계정 전환은 11월 14일 적용될 예정입니다.
상세한 사항은 첨부 자료를 참조해 주십시오.

문의사항이 있으시면, ERT 채널톡 또는 info@qesg.co.kr 로 문의 주십시오.

★ESG Reporting Tool 바로가기: https://report.qesg.co.kr
★QESG 홈페이지 바로가기: https://qesg.co.kr

감사합니다.
퀀티파이드이에스지 드림`,
          sender_email: 'info@info.qesg.co.kr',
          time_stamp: '2024-11-08 12:00:00',
          has_read: false,
          attachment: {
            name: '(QESG) ESG Reporting Tool 서비스 소개서_2024_11_가격정책업데이트_기존고객송부용v4',
            url: 'https://report.qesg.co.kr/document/(QESG) ESG Reporting Tool 서비스 소개서_2024_11_가격정책업데이트_기존고객송부용v4.pdf'
          }
        }
      ]
    };
  },
  computed: {
    ...mapState('story_board', ['editor_sb_toc']),
    ...mapGetters('story_board', ['sb_toc', 'selected_lv1', 'selected_lv2']),
    ...mapState('report_list', ['report_code', 'report_list']),
    ...mapState('logs', ['activity_logs', 'activity_logs_loaded', 'new_notice', 'mention_list']),
    ...mapState(['user_id', 'e_mail', 'is_admin']),
    userEmail() {
      return this.e_mail; // 사용자 이메일을 가져옵니다.
    },
    reversedMentionList() {
      return this.mention_list.slice().reverse();
    }
  },
  methods: {
    ...mapActions('logs', [
      'makeNoticeRead',
      'saveNotice',
      'readNoticesByUser',
      'deleteMentionFromList'
    ]),
    ...mapMutations('report_list', ['update_report_code', 'set_standard_mode']),
    ...mapMutations('story_board', ['update_disclosures_loaded']),
    ...mapActions('story_board', ['fetch_sb_toc']),
    ...mapMutations('story_board', ['update_selected_lv1', 'update_selected_lv2']),

    truncateText(text, maxLength) {
      if (text.length > maxLength) {
        return text.slice(0, maxLength) + '...';
      }
      return text;
    },

    updateQueryParam(key, value) {
      const url = new URL(window.location.href);
      if (value === null) {
        url.searchParams.delete(key);
      } else {
        url.searchParams.set(key, value);
      }
      window.history.pushState({}, '', url);
    },

    getReportName(report_code) {
      const idx = this.report_list.findIndex(x => x.report_code == report_code);
      if (idx > -1) {
        return this.report_list[idx].report_name;
      }
    },
    getMainColor(report_code) {
      const idx = this.report_list.findIndex(x => x.report_code == report_code);
      if (idx > -1) {
        return this.report_list[idx].main_color;
      }
    },

    getReadState(has_read) {
      if (has_read == false) {
        return '읽음 처리하기';
      }
    },

    handleNoticeRead(notice_id, has_read) {
      this.makeNoticeRead({ notice_id: notice_id, user_id: this.user_id, has_read: has_read });
    },

    openWriteNoticeModal() {
      this.$bvModal.show('write-notice-modal');
    },
    resetNoticeForm() {
      this.noticeForm.title = '';
      this.noticeForm.content = '';
    },
    submitNotice() {
      const noticeData = {
        title: this.noticeForm.title,
        content: this.noticeForm.content,
        sender_email: this.userEmail
      };
      this.saveNotice(noticeData)
        .then(() => {
          this.$bvModal.hide('write-notice-modal');
          this.resetNoticeForm();
          // 공지사항 목록 갱신
        })
        .catch(error => {
          error.message = '[공지사항 등록]' + error.message;
          this.$Sentry.captureException(error);
        });
    },
    openNoticeModal(notice) {
      this.selectedNotice = notice;
      this.$bvModal.show('notice-modal');
    },
    markNoticeAsRead(notice) {
      /**
       * TODO : 공지관련 로직이 구현되면 사용
       */
      // if (!notice.has_read) {
      //   this.makeNoticeRead({
      //     notice_id: notice.notice_id,
      //     user_id: this.user_id,
      //     has_read: true,
      //   });
      // }
      this.$bvModal.hide('notice-modal');
      localStorage.setItem('is_read', 'true');

      // Header 컴포넌트에 반영하기 위해 이벤트 방출 (선택사항)
      this.$emit('notice-read');
      window.location.reload();
    },
    toggleCollapse(type) {
      if (type === 'notices') {
        this.isNoticesCollapsed = !this.isNoticesCollapsed;
      } else if (type === 'activityLogs') {
        this.isActivityLogsCollapsed = !this.isActivityLogsCollapsed;
      } else if (type === 'messages') {
        this.isMessagesCollapsed = !this.isMessagesCollapsed;
      }
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    formatContent(content) {
      if (!content) return '';
      return content.replace(/\n/g, '<br>');
    },
    async handleMentionClick(mention) {
      if (!mention.report_code) return;
      this.handleNoticeRead(mention.id, true);

      if (this.report_code !== mention.report_code) {
        this.update_disclosures_loaded(false);
        this.update_report_code(mention.report_code);

        await this.fetch_sb_toc({
          report_code: mention.report_code,
          select_lv: true
        });
      }

      this.updateQueryParam('lv1', mention.sb_toc_lv1_key);
      this.updateQueryParam('lv2', mention.sb_toc_lv2_key);

      const routeData = {
        path: '/write_report/story_board',
        query: {
          lv1: mention.sb_toc_lv1_key,
          lv2: mention.sb_toc_lv2_key
        },
        hash: '#sr_content_' + mention.disclosure_id
      };

      if (location.pathname === '/write_report/story_board') {
        location.hash = '#sr_content_' + mention.disclosure_id;

        // TODO: lv2 바뀔때만 적용
        if (this.selected_lv2.key === mention.sb_toc_lv2_key) {
          ih.anchorGo(location.hash);
        } else {
          const goLv1 = this.editor_sb_toc.find(obj => obj.key === mention.sb_toc_lv1_key);
          if (goLv1) {
            this.update_selected_lv1({
              lv1_info: goLv1
            });

            const goLv2 = this.selected_lv1.children.find(
              obj => obj.key === mention.sb_toc_lv2_key
            );
            if (goLv2) {
              this.update_selected_lv2({
                lv2_info: goLv2
              });
            } else {
              this.$EventBus.$emit(
                'make-toast',
                '이동 불가',
                '해당 댓글이 존재하는 목차를 찾을 수 없습니다.'
              );
            }
          } else {
            this.$EventBus.$emit(
              'make-toast',
              '이동 불가',
              '해당 댓글이 존재하는 목차를 찾을 수 없습니다.'
            );
          }
        }
        // });
      } else {
        this.$router.push(routeData);
      }
    },
    async deleteMention(mentionId) {
      try {
        const response = await axios.delete(
          `${this.$store.state.backend_host}/notice/${mentionId}`
        );

        if (response.data && response.data.code) {
          this.$EventBus.$emit('make-toast', '삭제 완료', '메시지를 삭제했습니다.');
          await this.deleteMentionFromList({ id: response.data.deleted_id });
        } else {
          this.$EventBus.$emit(
            'make-toast',
            '삭제 실패',
            '메시지를 삭제하지 못했습니다. 다시 시도해주세요.'
          );
        }
      } catch (error) {
        error.message = '[멘션 삭제] ' + error.message;
        this.$Sentry.captureException(error);
      }
    }
  }
};
</script>

<style>
.collapse-icon {
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.button-with-icon:hover .collapse-icon {
  opacity: 1;
}

.notice-card:hover {
  border-color: var(--gray-700);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.delete-button {
  position: absolute;
  top: 4px;
  right: 4px;
  display: inline-flex;
}
</style>
